"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _mobileContent = _interopRequireDefault(require("./mobileContent"));
var _creatApp = require("@/api/creatApp");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    MobileContent: _mobileContent.default
  },
  props: {
    appId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      activeNum: 1,
      tableData: [{
        name: '背景色',
        size: '',
        type: 'bgColor',
        color: ''
      }, {
        name: '文字色值',
        size: '',
        type: 'textColor',
        color: ''
      }, {
        name: '客服图标',
        size: '180*180',
        type: 'customerServiceIcon',
        url: '',
        text: '客服'
      }, {
        name: '消息图标',
        size: '180*180',
        type: 'msgIcon',
        url: '',
        text: '消息'
      }, {
        name: '设置图标',
        size: '180*180',
        type: 'turnIcon',
        url: '',
        text: '设置'
      }],
      secondData: [{
        name: '结算说明色值',
        size: '',
        type: 'explain',
        color: '',
        bstop: 'true'
      }, {
        name: '收益明细按钮色值',
        size: '',
        type: 'detailedBtn',
        color: '',
        bstop: 'true'
      }, {
        name: '收益明细字体色值',
        size: '',
        type: 'detailedText',
        color: '',
        bstop: 'true'
      }, {
        name: '去提现按钮色值',
        size: '',
        type: 'cashBtn',
        color: '',
        bstop: 'true'
      }, {
        name: '去提现字体色值',
        size: '',
        type: 'cashText',
        color: '',
        bstop: 'true'
      }, {
        name: '收益明细图标',
        size: '500*600',
        type: 'detailedIcon',
        url: '',
        text: '收益明细'
      }, {
        name: '订单管理图标',
        size: '500*600',
        type: 'orderIcon',
        url: '',
        text: '订单管理'
      }, {
        name: '分享好友图标',
        size: '500*600',
        type: 'friendIcon',
        url: '',
        text: '分享好友'
      }]
    };
  },
  computed: {
    homeTopList: function homeTopList() {
      return this.tableData;
    },
    centerList: function centerList() {
      return this.secondData;
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (this.appId > 0) {
      this.getList();
    }
    setTimeout(function () {
      _this.dataBuff();
    }, 500);
  },
  methods: {
    getList: function getList() {
      var _this2 = this;
      var obj = {
        1: this.tableData,
        2: this.secondData
      };
      var arr = [];
      for (var i in obj) {
        arr.push("userCenter_".concat(i));
      }
      (0, _creatApp.getConfigList)({
        appId: this.appId,
        itemKeyList: arr
      }).then(function (res) {
        res.data.map(function (i) {
          switch (i.itemKey) {
            case 'userCenter_1':
              _this2.tableData = JSON.parse(i.itemValue);
              break;
            case 'userCenter_2':
              _this2.secondData = JSON.parse(i.itemValue);
              break;
            default:
              break;
          }
        });
      });
    },
    handleChildData: function handleChildData(val) {
      this.activeNum = val;
    },
    save: function save() {
      var _this3 = this;
      var obj = {
        1: this.tableData,
        2: this.secondData
      };
      (0, _creatApp.saveSetting)({
        appId: this.appId,
        itemKey: "userCenter_".concat(this.activeNum),
        itemValue: JSON.stringify(obj[this.activeNum])
      }).then(function (res) {
        _this3.$notify.success({
          title: '温馨提示',
          message: '操作成功'
        });
      });
    },
    dataBuff: function dataBuff() {
      // 确保第一次进来可以刷新子组件
      this.tableData.splice(0, 0);
      this.secondData.splice(0, 0);
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref, val, text) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              if (text) {
                val[text] = pictureUrl;
              } else {
                val.url = pictureUrl;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      function handleFileUpload(_x, _x2, _x3) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    del: function del(val, text) {
      var _this4 = this;
      this.$confirm('是否确认要删除该图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.$notify.success({
          title: '温馨提示',
          message: '成操作成功'
        });
        if (text) {
          val[text] = '';
        } else {
          val.url = '';
        }
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
};